<template>
	<div class="security">
		<div class="title">
			保证金详情
		</div>
		<div class="explain">
			<li>
				当前保证金说明：您参与该拍品的报名，保证金锁定成功。
			</li>
			<li class="payStatus">
				<span v-if="info.statusVal == 0">未支付</span>
				<span v-else-if="info.statusVal == 1">缴纳成功</span>
				<span v-else>释放成功</span>
			</li>
			<li>
				释放到余额的保证金，可免费原路退回支付账户。
			</li>
		</div>
		<div class="table" v-if="info.statusVal != 0">
			<div class="table-head">
				<div class="item">
					时间
				</div>
				<div class="item">
					状态
				</div>
				<div class="item">
					金额（元）
				</div>
				<div class="item">
					渠道
				</div>
			</div>
			<div class="table-body" v-for="(item,index) in record" :key="index">
				<div class="item">
					{{item.time}}
				</div>
				<div class="item">
					{{item.status}}
				</div>
				<div class="item">
					¥{{item.price}}
				</div>
				<div class="item">
					{{item.payment}}
				</div>
			</div>
		</div>
		<div class="order-title">
			订单信息
		</div>
		<div class="line">
			<div class="key">
				数字藏品名称：
			</div>
			<div class="value">
				{{info.name}}
			</div>
		</div>
		<div class="line">
			<div class="key">
				保证金金额：
			</div>
			<div class="value">
				<span>{{info.price}}元</span>
			</div>
		</div>
		<div class="line">
			<div class="key">
				支付渠道：
			</div>
			<div class="value">
				{{info.statusVal == 0 ? '未支付' : info.payment}}
			</div>
		</div>
		<div class="hint">
			若竞拍失败（含未出价、未竞拍成功），保证金会在拍卖结束后24小时内释放并自动退回到您的银行卡（极少情况下会退回到您的支付宝余额）<br>
			退款到账一般需3-5个工作日<br>
			如遇问题，请联系拍卖客服帮您处理，拍卖客服电话：<span>{{$store.state.websiteConfig.contact[0]['value']}}</span>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'security',
		data() {
			return {
				id: '',
				info: {
					price: '1000.00',
					payment: '支付宝/微信/银联',
					name: '数字藏品名称数字藏品名称数字藏品名称数字藏品名称数字藏品名称',
					statusVal: 1
				},
				record: []
			};
		},
		methods: {
			fetchData() {
				this.$api.frontDepositDetail({
					id: this.id
				}, res => {
					console.log(res)
					if (res.code == 200) {
						this.info = {
							price: res.data.bondPrice,
							payment: res.data.channel == '1' ? '微信' : '支付宝',
							name: res.data.lotName,
							statusVal: res.data.payStatus
						}
						let pay = {
							time: res.data.payTime,
							status: '缴费成功',
							price: res.data.bondPrice,
							payment: res.data.channel == '1' ? '微信' : '支付宝'
						}
						let refund = {
							time: res.data.returnTime,
							status: '释放成功',
							price: res.data.bondPrice,
							payment: res.data.channel == '1' ? '微信' : '支付宝'
						}
						let array = [pay]
						if (this.info.statusVal == 2) {
							array.push(refund)
						}
						this.record = array
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.id = this.$route.query.id
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.security {
		width: 100%;

		.title {
			width: 100%;
			height: 50px;
			display: flex;
			align-items: center;
			font-size: @vue-font-size-base;
			border-bottom: 2px solid @vue-border-color-red;
			box-sizing: border-box;
		}

		.explain {
			width: 100%;
			border: 1px solid @vue-border-color;
			box-sizing: border-box;
			background: @vue-bg-color-grey;
			margin-top: @vue-spacing-col-lg;
			padding: @vue-spacing-col-base @vue-spacing-row-base;
			box-sizing: border-box;

			li {
				width: 100%;
				line-height: 30px;
				font-size: @vue-font-size-sm - 2;
			}

			.payStatus {
				color: @vue-text-color-red;
				font-size: @vue-font-size-base;
				line-height: 50px;
			}
		}

		.table {
			width: 100%;
			border: 1px solid @vue-border-color;
			box-sizing: border-box;
			margin-top: @vue-spacing-col-lg;

			.table-head,
			.table-body {
				width: 100%;
				display: flex;
				justify-content: space-between;
				border-bottom: 1px solid @vue-border-color;

				.item {
					width: 25%;
					height: 100%;
					border-right: 1px solid @vue-border-color;
					display: flex;
					justify-content: center;
					align-items: center;
				}

				.item:last-child {
					border: none;
				}
			}

			.table-head {
				background: @vue-bg-color-grey;
				height: 40px;
			}

			.table-body {
				height: 60px;
			}

			.table-body:last-child {
				border: none
			}
		}

		.order-title {
			width: 100%;
			height: 50px;
			display: flex;
			align-items: center;
			font-size: @vue-font-size-sm;
			font-weight: bold;
			margin-top: @vue-spacing-col-lg;
		}

		.line {
			width: 100%;
			height: 50px;
			border-bottom: 1px dashed @vue-border-color;
			display: flex;

			.key,
			.value {
				height: 100%;
				display: flex;
				align-items: center;
			}

			.key {
				justify-content: flex-end;
			}

			.value {
				span {
					color: @vue-text-color-red;
				}
			}
		}

		.hint {
			width: 100%;
			line-height: 36px;
			margin-top: @vue-spacing-col-lg;
			margin-bottom: @vue-spacing-col-lg * 2;
			color: @vue-text-color-grey;

			span {
				color: @vue-text-color-red;
			}
		}
	}
</style>
